import { render, staticRenderFns } from "./InstanceConfiguration.vue?vue&type=template&id=48aa977c&"
import script from "./InstanceConfiguration.vue?vue&type=script&lang=js&"
export * from "./InstanceConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports